import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M12.819 12L9 8.11 10.09 7 15 12l-4.91 5L9 15.89 12.819 12z"
      ></path>
    </svg>
  )
}

export default Icon
